import request from "@/utils/request";

export function getAiConversationsList(data) {
  return request({
    method: "post",
    url: "/ai/conversations",
    data,
  });
}

export function askAi(data) {
  return request({
    method: "post",
    url: "/ai/conversations/ask",
    data,
    responseType: "stream",
  });
}

export function getConversationsLookup(data) {
  return request({
    method: "post",
    url: "/ai/conversations/lookup",
    data,
  });
}

export function deleteConversation(data) {
  return request({
    method: "delete",
    url: "/ai/conversations/delete",
    data,
  });
}

export function getAiTopicTrending(data) {
  return request({
    method: "post",
    url: "/ai/conversations/topics/trending",
    data,
  });
}

export function getHomeSearchType() {
  return request({
    method: "get",
    url: "/home/navigation",
  });
}

export function getNewsList(data) {
  return request({
    method: "post",
    url: "/companies/news",
    data,
  });
}

export function getJobPostingList(data) {
  return request({
    method: "post",
    url: "/companies/jobs",
    data,
  });
}

// Windowed insight aggregates for one company (KPIs + weekly series + breakdowns), per source.
export function getJobInsights(data, options = {}) {
  return request({ method: "post", url: "/companies/jobs/insights", data, ...options });
}

export function getAdInsights(data, options = {}) {
  return request({ method: "post", url: "/companies/advertisements/insights", data, ...options });
}

export function getNewsInsights(data, options = {}) {
  return request({ method: "post", url: "/companies/news/insights", data, ...options });
}

export function getAdList(data, options = {}) {
  return request({
    method: "post",
    url: "/companies/advertisements",
    data,
    ...options,
  });
}

// Full single-ad detail for the click-through dialog (body copy, target markets, dates, reach, placements).
export function getAdDetail(data, options = {}) {
  return request({
    method: "post",
    url: "/companies/advertisements/lookup",
    data,
    ...options,
  });
}

// Company-detail list exports (CSV blob). Charge data_export_credit per row, same as company/people export.
export function exportJobPostings(data) {
  return request({ method: "post", url: "/companies/jobs/export", data, responseType: "blob" });
}

export function exportAdvertisements(data) {
  return request({ method: "post", url: "/companies/advertisements/export", data, responseType: "blob" });
}

export function exportNews(data) {
  return request({ method: "post", url: "/companies/news/export", data, responseType: "blob" });
}

export function invitePeople(data) {
  return request({
    method: "post",
    url: "/referrals/invite",
    data,
  });
}

export function searchTrending(data) {
  return request({
    method: "post",
    url: "/companies/search/trending",
    data,
  });
}

export function getOnboardingList(data, options = {}) {
  return request({
    method: "post",
    url: "/home/onboarding",
    data,
    ...options,
  });
}

export function getOnboardingBannerList(data, options = {}) {
  return request({
    method: "post",
    url: "/home/onboarding/banners",
    data,
    ...options,
  });
}

export function getHomeComponents(data, options = {}) {
  return request({
    method: "post",
    url: "/home/components",
    data,
    ...options,
  });
}
export function updateHomeComponents(data, options = {}) {
  return request({
    method: "post",
    url: "/home/components/update",
    data,
    ...options,
  });
}

export function deleteHomeComponents(data, options = {}) {
  return request({
    method: "delete",
    url: "/home/components/delete",
    data,
    ...options,
  });
}

export function getGalleries(params) {
  return request({
    method: "get",
    url: "/companies/news/galleries",
    params,
  });
}

export function getCategories(params) {
  return request({
    method: "get",
    url: "/companies/news/categories",
    params,
  });
}

export function getSimilarCompany(data, options = {}) {
  return request({
    method: "post",
    url: "/companies/search/similar",
    data,
    ...options
  });
}
